import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

// Async thunk for fetching background banners
export const fetchfooterproductorcategory = createAsyncThunk(
  "footerproductorcategory/fetchfooterproductorcategory",
  async () => {
    const response = await axios.get(apiurl + "footerproductorcategory");
    return response.data.data; // Assuming the banner data is in `data`
  }
);

// Initial state
const initialState = {
  footerproduct: [], // Correct key here
  loading: false,
  status: "idle",
  error: null,
};

// Slice for background banners
const Fetchfooterproductorcategory = createSlice({
  name: "footerproductorcategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchfooterproductorcategory.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchfooterproductorcategory.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.footerproduct = action.payload; // Corrected to `backgroundbanner`
      })
      .addCase(fetchfooterproductorcategory.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default Fetchfooterproductorcategory.reducer;
